import { render, staticRenderFns } from "./ShowNewAddDialog.vue?vue&type=template&id=4ecd3168&"
import script from "./ShowNewAddDialog.vue?vue&type=script&lang=js&"
export * from "./ShowNewAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShowNewAddDialog.vue?vue&type=style&index=0&id=4ecd3168&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports